
export default function Experience() {
  const stats = [
    { number: '150', label: 'Clientes Atendidos' },
    { number: '50', label: 'Projetos de IA' },
    { number: '98', label: 'Taxa de Satisfação' },
    { number: '5', label: 'Anos de Experiência' }
  ];

  return (
    <section id="experiencia" className="py-16 sm:py-20 bg-dark-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div>
            <span className="text-sm font-semibold text-red-500 tracking-wider uppercase mb-4 block">
              MINHA TRAJETÓRIA
            </span>
            <p className="text-2xl sm:text-3xl lg:text-4xl text-white leading-relaxed font-medium">
              Com anos de experiência em tecnologia e inovação, dedico-me a conectar pessoas às melhores soluções em <span className="text-red-500">inteligência artificial</span> e <span className="text-cyan-400">automação inteligente</span>, transformando desafios em oportunidades de crescimento.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4 sm:gap-6">
            {stats.map((stat, index) => (
              <div 
                key={index}
                className="bg-dark-700 rounded-2xl p-4 sm:p-6 border border-dark-600 hover:border-red-600/30 transition-all duration-300"
              >
                <div className="text-3xl sm:text-4xl lg:text-5xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-red-500 to-red-600 mb-2">
                  {stat.number}
                  <span className="text-red-600">+</span>
                </div>
                <p className="text-gray-400 text-xs sm:text-sm font-medium">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
